import Insurances from "./Insurances";
export default Insurances;
